// extracted by mini-css-extract-plugin
export default {"body":"styles_body__U-gUK"};